import { render } from "./Footer.html?vue&type=template&id=758e83a0&scoped=true&ts=true&external"
import script from "./Footer.ts?vue&type=script&lang=ts&external"
export * from "./Footer.ts?vue&type=script&lang=ts&external"

import "./Footer.scss?vue&type=style&index=0&id=758e83a0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758e83a0"]])

export default __exports__